<template>
  <van-form
    class="form-container"
    ref="form"
    :show-error="false"
    :scroll-to-error="true"
    :submit-on-enter="false"
    @submit.native.prevent
  >
    <template v-for="(item, index) in formLine">
        <template v-if="item.title && !item.innerFormLine && !item.hidden">
          <div class="title" :class="item.required && 'required'" :key="item.title">
            {{  item.title }}
          </div>
        </template>
        <template v-if="!item.hidden">
          <template>
            <slot :name="item.slotName" :lineName="index" :line="item" :data="formatData">
              <van-row :key="index">
                <van-col :span="24">
                  <vanCustomFieldVue
                    :field="item"
                    :data="formatData"
                  >
                  </vanCustomFieldVue>
                </van-col>
              </van-row>
            </slot>
          </template>
        </template>
    </template>
  </van-form>
</template>

<script>
// import _ from 'lodash'
import vanCustomFieldVue from './vanCustomField.vue'

export default {
  name: 'ResumeForm',
  components: {
    vanCustomFieldVue
  },
  props: {
    formLine: {
      required: true
    },
    data: {
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      formatData: {}
    }
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  created () {

  },
  methods: {
    async submit () {
      try {
        await this.form.validate()
      } catch (e) {
        this.errorInfo = e
        this.$nextTick(() => {
          this.$el.querySelector('.van-field__error-message').scrollIntoView({ block: 'center', behavior: 'smooth' })
        })
        return false
      }
      return true
    },
    async clearValidate (props) {
      let form = this.form
      if (!form) {
        await this.$nextTick()
        form = this.form
      }
      return form.resetValidation(props)
    },
    async validateField (props) {
      try {
        await this.form.validate(props)
      } catch (e) {
        this.errorInfo = e
        return false
      }
      return true
    }
  },
  watch: {
    data: {
      immediate: true,
      handler () {
        this.formatData = this.data
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.form-container.van-form {
  .innerForm {
    padding: 0;
  }

  .title {
    color: #606266;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    font-style: normal;
    margin: 20px 0 16px 0;
  }

  .required {
    &::after {
      position: relative;
      color: #ea7f7f;
      font-size: 14px;
      content: '*';
    }
  }

  .van-row {
     margin-bottom: 16px;
  }
}
</style>
